import { RadioInformationModel } from '@sxm-de/dev-kits/microservices-sdk/types';
import { VehicleState } from '@sxm-de/dev-kits/web-sdk/types';

export function mapVehicleState(
    radioInfo: RadioInformationModel,
): VehicleState {
    return {
        deviceId: '',
        radioId: radioInfo.deviceInformation.radioId || '',
        oemDriverId: '',
        lifecycleState: null,
        vehicleState: {
            year: radioInfo.deviceInformation.vehicle?.year || 0,
            make: radioInfo.deviceInformation.vehicle?.make || '',
            model: radioInfo.deviceInformation.vehicle?.model || '',
            vin: radioInfo.deviceInformation.vehicle?.vin || '',
        },
        deviceSource: 'SMS',
    };
}
